<div class="d-flex w-100 h-100 mx-auto flex-column cover-container">

  <header class="masthead mb-auto bg-success">
    <div class="inner container">
      <h3 class="masthead-brand">{{title | titlecase}}</h3>
      <nav class="nav nav-masthead justify-content-center">
        <a class="nav-link active" href="#">Home</a>
        <a class="nav-link" href="#">Menu</a>
        <a class="nav-link" href="#">Contact</a>
      </nav>
    </div>
  </header>

  <main role="main" class="container inner cover">
    <h1 class="cover-heading">Welcome to {{title | titlecase}}</h1>
    <p class="lead">Fresh, healthy and nutritious food</p>
    <p class="lead">
      <a href="#" class="btn btn-lg btn-success">Order Online</a>
    </p>
  </main>

  <footer class="mastfoot mt-auto bg-dark">
    <div class="inner container">
      <p>Powered by <a href="https://www.mealjunction.com/">Mealjunction</a></p>
    </div>
  </footer>
